import React, {useContext, useEffect} from 'react'
import farmerContext from "../../../context/farmer/farmerContext";
import ManageEquipmentTableRow from "./ManageEquipmentTableRow";


const ManageEquipmentTable = () => {

    const FarmerContext = useContext(farmerContext);

    const { getEquipmentRequests, farmer } = FarmerContext;

    const { equipmentRequests}= farmer;

    useEffect(() => {
        getEquipmentRequests()
        //eslint-disable-next-line
    }, []);
    return (
            <div className="content-wrapper">
                <div className="container-fluid">

                <h3 class="make-bold">View Requests</h3>
                <p>View Possible Request</p>

                <div class="dashboard-inner-view">
                    <div class="row mt-3">
                        <div class="col-lg-12">
                            <div class="table-responsive">
                                <table class="table table-striped table-hover">
                                    <thead class="thead-dark">
                                        <tr>
                                            <th>#</th>
                                            <th>Equipment Name</th>
                                            <th>Service</th>
                                            <th>Caution fee</th>
                                            <th>Start Date</th>
                                            <th>Status</th>
                                            <th>Hire Again</th>
                                        </tr>
                                    </thead>
                                        {
                                            equipmentRequests !== null ? equipmentRequests.map((equipmentRequest, index) => (
                                                <ManageEquipmentTableRow equipmentRequest={equipmentRequest} sn={index + 1} key={equipmentRequest.id} />
                                            )) : <span>No data to display</span>
                                        }
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
            </div>
        </div>
    )
}

export default ManageEquipmentTable
